import { isRTLLocale } from '@wix/cashier-common/dist/src/utils/isRTLLocale';
import { createSelector } from 'reselect';
import { ViewMode } from '@wix/cashier-common/dist/src/types/ViewMode';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { IRequestStateMeta } from '../reducers/requestsState';
import { DemoViewMode } from '../types/DemoViewMode';
import { IStoreState } from '../types/StoreState';
import { Experiment } from '../types/Experiment';

const selectFetchCards = (state: IStoreState) => state.requestsState.fetchCards;
export const selectIsRTLLocale = (state: IStoreState) => isRTLLocale(state.appState.locale);
const selectFetchFreeText = (state: IStoreState) => state.requestsState.fetchFreeText;
const selectFetchDemoCards = (state: IStoreState) => state.requestsState.fetchDemoCards;
const selectFetchRecurringPaymentMethods = (state: IStoreState) => state.requestsState.fetchRecurringPaymentMethods;
export const selectRecurringPaymentMethods = (state: IStoreState) => state.domain.paymentMethods.recurringMethods;
export const selectMarkCardPrimaryState = (state: IStoreState): IRequestStateMeta =>
  state.requestsState.markCardPrimary;
export const selectDeleteCardState = (state: IStoreState) => state.requestsState.deleteCard;
export const selectDeletePrimaryCardState = (state: IStoreState) => state.requestsState.deletePrimaryCard;
export const selectFreeText = (state: IStoreState) => state.appState.freeText;
export const selectViewMode = (state: IStoreState): ViewMode => state.appState.viewMode;
export const selectDemoViewMode = (state: IStoreState): DemoViewMode => state.appState.demoViewMode;
export const selectAppSessionId = (state: IStoreState): string => state.appState.appSessionId;

export const selectCanAddPaymentMethod = createSelector(selectRecurringPaymentMethods, (recurringMethods) => {
  if (experimentsService.isEnabled(Experiment.DisableAddCardInMyWallet)) {
    return false;
  }
  return recurringMethods.some((pm) => pm.paymentMethod === PaymentMethod.CreditCard);
});

export const selectAppLoaded = createSelector(
  selectFetchCards,
  selectFetchFreeText,
  selectFetchDemoCards,
  selectViewMode,
  selectFetchRecurringPaymentMethods,
  (fetchCardsState, fetchFreeTextState, fetchDemoCardsState, viewMode, fetchRecurringPaymentMethods) => {
    return (
      (viewMode === 'site' ? !!fetchCardsState.success || !!fetchCardsState.error : !!fetchDemoCardsState.success) &&
      (!!fetchRecurringPaymentMethods.success || !!fetchRecurringPaymentMethods.error) &&
      (!!fetchFreeTextState.success || !!fetchFreeTextState.error)
    );
  },
);

export const selectMarkCardPrimaryLoading = createSelector(
  selectMarkCardPrimaryState,
  (markCardPrimaryState) => !!markCardPrimaryState.loading,
);

export const selectMarkCardPrimaryFailed = createSelector(
  selectMarkCardPrimaryState,
  (markCardPrimaryState) => !!markCardPrimaryState.error,
);

export const selectRemoveLoading = createSelector(
  selectDeleteCardState,
  selectDeletePrimaryCardState,
  (deleteCardState, deletePrimaryCardState) => !!deleteCardState.loading || !!deletePrimaryCardState.loading,
);

export const selectRemoveError = createSelector(
  selectDeleteCardState,
  selectDeletePrimaryCardState,
  (deleteCardState, deletePrimaryCardState) => !!deleteCardState.error || !!deletePrimaryCardState.error,
);
